import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import type { Locale } from '../../i18n/translation.model';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { AuthService } from '../../services/auth.service';
import { LocaleService } from '../../services/locale.service';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  private readonly authService = inject(AuthService);
  private readonly localeService = inject(LocaleService);

  protected readonly isMobileMenuOpen = signal(false);
  protected readonly auth = this.authService.auth;
  protected readonly locale = this.localeService.locale;
  protected readonly userDisplayName = computed(() => {
    const user = this.auth()?.user;
    if (!user) {
      return '';
    }

    return `${user.firstName} ${user.lastName}`.trim();
  });

  toggleMobileMenu(): void {
    this.isMobileMenuOpen.update((v) => !v);
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen.set(false);
  }

  logout(): void {
    this.authService.logout();
    this.closeMobileMenu();
  }

  setLocale(locale: Locale): void {
    this.localeService.setLocale(locale);
  }
}
